module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABYUlEQVQ4jZ3TP0hXcRQF8E/m2KCEuBQOiVFkQ1EJDf7DiqihJSwaQpoasqElorktGnRTnNTBpX4SQQUJ9hvUoShrKWiJGq2l0eTCffF4/F6DZ3v3nnu+99537p5Go6GCftzDIA5k6geaeIyNMr29UvwEk/iKZXzANo7hPNYxh4lWAi9wAVfwtNpWYgwvU/B0hNoyMZ3FByvF13Cr9P0KnTiFpaKDQ7iNi/heefF+7mGmFPuFM1jDiRB4hJ85QhXf8KdFPHbxCVMxwggWa2b+H2ajgxDYj3e7EIgO2oolbteQIr+3Jve3IGzheA2pC901ucMhEgKrGK8hXcVQTe4mNkPgAXpwtgVpFJdaxI/gJO7Eb9zEPN6iA79LxL40ThlR8zlN1SysfAO9aZJhrGQ8jFRG2Dce+oJzhVqBASzgTV7cM3zMbR/F5RzzeXms6jVez7t4iLvYl/Fw4/s8ptf/2NgB6edCpxo2I20AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/iconOrderNo.png
// module id = e4i/
// module chunks = 3